import { initSentry } from "./lib/sentry";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initWebVitals } from "./lib/web-vitals-reporter";
import { registerSW } from "virtual:pwa-register";
import { initClientErrorBuffer } from "./lib/bug-report-context";

// Initialize Sentry APM before anything else
initSentry();
initClientErrorBuffer();

// Register PWA service worker with automatic update strategy.
// In autoUpdate mode the new service worker activates and the page reloads
// automatically; onNeedRefresh is never fired, so no prompt path is needed.
registerSW({
  onOfflineReady() {
    console.log("[PWA] App ready to work offline.");
  },
  onRegisteredSW(_swUrl, registration) {
    // Poll so long-lived sessions pick up new deployments without a manual reload.
    if (registration) {
      setInterval(() => {
        registration.update();
      }, 15 * 60 * 1000);
    }
  },
});

createRoot(document.getElementById("root")!).render(<App />);

initWebVitals();
